import * as React from 'react';

import { useTopBarCount } from '../../hooks/topBar';

export const TotalCountContainer = () => {
  const topBarCount = useTopBarCount();

  // oxlint-disable-next-line react/jsx-no-useless-fragment
  return <>{topBarCount.text}</>;
};
